var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSparkle = function SvgAiSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    fillRule: "evenodd",
    stroke: "#FFAC33",
    d: "M17.892 1.719a1 1 0 0 0-1.906-.042l-2.872 8.403-6.473 2.486a1 1 0 0 0-.05 1.847l6.496 2.91 2.457 7.972a1 1 0 0 0 1.897.043l2.884-8.017 6.106-2.919a1 1 0 0 0-.052-1.827l-6.032-2.472z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    fillRule: "evenodd",
    stroke: "#FFCC4D",
    d: "M5.826 2.19a1 1 0 0 0-1.886-.045l-.71 1.87-1.557.54a1 1 0 0 0-.047 1.872l1.576.637.602 1.76a1 1 0 0 0 1.875.047L6.4 7.062l1.496-.644a1 1 0 0 0-.05-1.856l-1.42-.524zM9.103 18.243a1 1 0 0 0-1.922-.04l-.817 2.634-1.754.742a1 1 0 0 0-.053 1.818l1.782.88.698 2.492a1 1 0 0 0 1.914.041l.828-2.537 1.687-.888a1 1 0 0 0-.055-1.797L9.8 20.862z",
    clipRule: "evenodd"
  })));
};
export default SvgAiSparkle;